import React from "react"
import { EditorState, ContentState, convertToRaw, Modifier } from "draft-js"

const Editor =
  typeof window !== "undefined" ? require("react-draft-wysiwyg").Editor : null

import draftToHTML from "draftjs-to-html"
import draftFromHTML from "html-to-draftjs"

class TextArea extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      editorState: null,
    }
  }

  componentDidMount() {
    let editorState

    if (this.props.html) {
      const blocksFromHtml = draftFromHTML(this.props.html)
      const { contentBlocks, entityMap } = blocksFromHtml
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      )
      editorState = EditorState.createWithContent(contentState)
    } else {
      editorState = EditorState.createEmpty()
    }

    this.setState({
      editorState,
    })
  }

  onEditorStateChange = (editorState) => {
    this.setState({ editorState }, () => {
      if (this.props.onChange) {
        let html = draftToHTML(
          convertToRaw(this.state.editorState.getCurrentContent())
        )

        this.props.onChange({
          target: {
            name: this.props.name,
            value: html,
          },
          persist: () => {},
        })
      }
    })
  }

  validate = () => {
    let contentState = this.state.editorState.getCurrentContent()

    if (!contentState.hasText()) {
      return false
    }

    return true
  }

  getValue = () => {
    let html = draftToHTML(
      convertToRaw(this.state.editorState.getCurrentContent())
    )

    return {
      type: "text-content",
      props: { html },
    }
  }

  handlePastedText = (text, html) => {
    const { editorState } = this.state
    const isLink = html && html.indexOf("</a>") > -1

    let blockMap

    if (isLink) {
      html = html.replace(/\<style(.|\n)+\<\/style\>/, "")

      const blocksFromHtml = draftFromHTML(html)
      const { contentBlocks, entityMap } = blocksFromHtml
      blockMap = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      ).getBlockMap()
    } else {
      blockMap = ContentState.createFromText(text).getBlockMap()
    }

    let newState = Modifier.replaceWithFragment(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      blockMap
    )

    this.onEditorStateChange(
      EditorState.push(editorState, newState, "insert-fragment")
    )

    return true
  }

  render() {
    if (!Editor) return null
    return (
      <div
        className={
          "editor-container" +
          (this.props.className ? " " + this.props.className : "")
        }
      >
        <Editor
          editorState={this.state.editorState}
          editorClassName="editor-body"
          onEditorStateChange={this.onEditorStateChange}
          toolbarClassName="toolbar"
          toolbar={this.props.toolbarConfig}
          handlePastedText={this.handlePastedText}
          stripPastedStyles={true}
          handleReturn={this.props.handleReturn}
        />
      </div>
    )
  }
}

TextArea.defaultProps = {
  toolbarConfig: {
    options: [
      "inline",
      "blockType",
      "fontSize",
      "fontFamily",
      "list",
      "textAlign",
      "colorPicker",
      "link",
      "history",
    ],
    inline: {
      options: ["bold", "italic", "underline", "strikethrough"],
      bold: { className: "toolbar-button" },
      italic: { className: "toolbar-button" },
      underline: { className: "toolbar-button" },
      strikethrough: { className: "toolbar-button" },
    },
    blockType: {
      className: "toolbar-dropdown-button",
      dropdownClassName: "toolbar-dropdown",
    },
    fontSize: {
      className: "toolbar-dropdown-button",
      dropdownClassName: "toolbar-dropdown",
    },
    fontFamily: {
      className: "toolbar-dropdown-button",
      dropdownClassName: "toolbar-dropdown",
    },
    list: {
      unordered: { className: "toolbar-button" },
      ordered: { className: "toolbar-button" },
      indent: { className: "toolbar-button" },
      outdent: { className: "toolbar-button" },
    },
    textAlign: {
      left: { className: "toolbar-button" },
      right: { className: "toolbar-button" },
      center: { className: "toolbar-button" },
      justify: { className: "toolbar-button" },
    },
    colorPicker: { className: "toolbar-button" },
    link: {
      link: { className: "toolbar-button" },
      unlink: { className: "toolbar-button" },
    },
    history: {
      undo: { className: "toolbar-button" },
      redo: { className: "toolbar-button" },
    },
  },
}

export default TextArea
